import urlAnchorParse from 'components/url-anchor-parse';
import { createHashHistory } from 'history';

const history = createHashHistory({
    hashType: 'noslash',
});

let urlParamCache = null;

/** Will be removed on EVERY pushParam call (e.g. to reset a paging) */
const filterParams = ['page'];

// Update param cache on history change
history.listen(({ location, action }) => {
    urlParamCache = urlAnchorParse.parse(location.pathname);
});

function getUrlParams() {
    if (!urlParamCache) {
        urlParamCache = urlAnchorParse.parse(history.location.pathname);
    }
    return urlParamCache;
}

function pushParams(params, removeFilteredParams = true) {
    if (removeFilteredParams) {
        filterParams.forEach((toFilter) => {
            delete params[toFilter];
        });
    }
    let newHist = '/' + urlAnchorParse.makeUrl(params);
    if (decodeURI(newHist) !== history.location.pathname) {
        history.push(newHist);
    }
}

function removeParamFromCache(key) {
    if (getUrlParams()) {
        delete urlParamCache[key];
    }
}

export default {
    history,
    getUrlParams,
    pushParams,
    removeParamFromCache,
    filterParams,
};
